import axiosInstance from "~/shared/api/axios-instance";

export async function fetchEventSourceKeyWhitelist(
  clientUid: string,
): Promise<string[]> {
  const { data } = await axiosInstance.get<{ keywords: string[] }>(
    `clients/${clientUid}/event-source-key-whitelist/`,
  );
  return data.keywords;
}

export async function updateEventSourceKeyWhitelist(
  clientUid: string,
  keywords: string[],
): Promise<string[]> {
  const { data } = await axiosInstance.put<{ keywords: string[] }>(
    `clients/${clientUid}/event-source-key-whitelist/`,
    { keywords },
  );
  return data.keywords;
}
